<template>
    <div id="myAccount">
		<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
<el-tab-pane label="个人信息" name="one">
				<personalCenter></personalCenter>
			</el-tab-pane>


		    <el-tab-pane label="账户流水" name="two">
				<el-table :data="tableData" border
				fit
				highlight-current-row
				style="width: 100%;"
				:header-cell-style="{background:'#f5f5f5'}"
				 >
				    <el-table-column prop="typeName" label="账户类型" align="center"></el-table-column>
				    <el-table-column prop="balanceRmb" label="账户余额（元）" align="center"></el-table-column>
				    <el-table-column prop="totalHistoryRmb" label="历史总额（元）" align="center"></el-table-column>
				    <!-- <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column> -->
				    <el-table-column label="操作" align="center" v-if="this.isShowLog">
				        <template slot-scope="scope">
				            <el-button type="primary" size="small" 
                             @click="getAccountDataHandler(scope.row)" icon="el-icon-search">流水查询</el-button>
				            <!-- <el-button type="text" size="small" v-if="scope.row.type == 10" @click="appliyRmb()" >申请提现</el-button>
				              <el-button type="text" size="small" v-if="scope.row.type == 20" @click="appliyRmbs()" >
								  <span style="color: red;">
									  余额预警
								  </span>
							  </el-button> -->
				        </template>
				    </el-table-column>
				</el-table>  
				
				<div v-if="showAccount">
				    <h3>{{ currentAccount }} - 交易流水</h3>
				    <el-table :data="tbpg.tableData" border 
					 fit
					 highlight-current-row
					 style="width: 100%;"
					 :header-cell-style="{background:'#f5f5f5'}"
					 >
				        <el-table-column prop="accountBalanceRmb" label="账户余额（元）" align="center"></el-table-column>
				        <el-table-column prop="amountRmb" label="交易金额（元）"  align="center"></el-table-column>
				        <el-table-column prop="createTime" label="交易时间"  align="center"></el-table-column>
				        <el-table-column prop="ioTypeName" label="类型"  align="center"></el-table-column>
				        <el-table-column prop="remark" label="备注"  align="center"></el-table-column>
				    </el-table>
				    <el-pagination
				        @size-change="handleSizeChange"
				        @current-change="handleCurrentChange"
				        :current-page="tbpg.currentPage"
				        :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
				        :page-size="tbpg.pageSize"
						background
				        layout="total, sizes, prev, pager, next, jumper"
				        :total="tbpg.total">
				    </el-pagination>  
				</div>
			</el-tab-pane>
			
		  </el-tabs>
		

        <el-dialog :append-to-body="true"  title="提现申请" :visible.sync="applyVisible"  width="500px" @close="cancelToApply()" :close-on-click-modal="false">

            <el-form  ref="withdrawalForm" :model="withdrawalForm" label-width="100px" label-position="left" >
                <!-- <el-form-item label="收款账户：" >
                    <el-select v-model="withdrawalForm.withdrawalId" placeholder="请在系统右上角 个人中心 创建">
                        <el-option
                          v-for="item in withdrawalOptions"
                          :key="item.id"
                          :label="item.cashType==1?'支付宝 - '+item.payeeAccount:'银行卡 - '+item.payeeAccount"
                          :value="item.id">
                        </el-option>
                    </el-select> 
                </el-form-item> -->
                <el-form-item style="margin-top: 25px;" label="支付宝账户：" >
                    <el-input placeholder="支付宝账户" v-model="withdrawalForm.wxPhone"></el-input>
                </el-form-item>
                <el-form-item style="margin-top: 25px;" label="提现金额：" >
                    <el-input placeholder="请输入提现金额" v-model="input1" v-model.trim="withdrawalForm.priceRmb" @keyup="formatPrice()" 
                        @blur="formatPrice()">
                        <template slot="prepend">￥</template>
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>

                <el-form-item style="margin-top: 25px;" label="提现密码：" >
                    <el-input placeholder="请输入密码" v-model="withdrawalForm.paypass" show-password></el-input>
                </el-form-item>

            </el-form>

            <p style="margin-top: 10px; margin-bottom: 50px;color: #606266;">
            最小提现金额{{cashoutMinAmount}}元，单笔提现手续费率百分之{{cashoutFee}}</p>
            <el-button @click="withdrawalForm.priceRmb = allBalanceRmb">全部提现</el-button>
            <el-button @click="cancelToApply()">取 消</el-button>
            <el-button type="primary" @click="applyCashOutHandler()">申 请</el-button>
        </el-dialog> 


                <el-dialog :append-to-body="true"  title="预警配置" :visible.sync="applyVisibles"  width="500px" @close="cancelToApply()" :close-on-click-modal="false">

            <el-form  ref="agentInfos" :model="agentInfos" label-width="100px" label-position="left" >
         

                <el-form-item style="margin-top: 25px;" label="预警金额：" >
                    <el-input placeholder="预警金额为0时 将自动取消预警" v-model="input1" v-model.trim="agentInfos.idCard" @keyup="formatPrice()" 
                        @blur="formatPrice()">
                        <template slot="prepend">￥</template>
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>

                <el-form-item style="margin-top: 25px;" label="通知手机号：" >
                    <el-input placeholder="通知手机号" v-model="agentInfos.bindMobile"></el-input>
                </el-form-item>

            </el-form>

            <p style="margin-top: 10px; margin-bottom: 50px;color: red;">
              配置后，系统将会在您预存不足时 发送短信提醒通知！(预警金额为0时 将自动取消预警)</p>
            <el-button @click="cancelToApply()">取 消</el-button>
            <el-button type="primary" @click="applyCashOutHandlers()">配 置</el-button>
        </el-dialog> 

    </div>
</template>
<script>
import {getAgentAccount, getAccountData} from '@/api/home.js'
import {applyCashOut } from '@/api/finance.js';
import common from '@/utils/common.js'
import {mapGetters } from "vuex";
import personalCenter from "./personalCenter.vue"
export default {
	components:{
		personalCenter
	},
    data(){
        return {
            isShowLog:localStorage.getItem('accountName')==='xingdawulian008'||localStorage.getItem('accountName')==='xiaoyu1'||localStorage.getItem('accountName')==='malijie'
            ||localStorage.getItem('accountName')==='test01' ? true:false,

			activeName:'one',
            tableData: [],
            showAccount: false,            
            currentId: '',
            currentAccount: '',
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            allBalanceRmb: 0,
            agentInfos:{
                idCard:'',
                bankName:'',
                bindMobile:''
            },

            applyVisible: false,
            applyVisibles: false,
            withdrawalOptions: [],
            withdrawalForm:{
                withdrawalId: null,
                priceRmb: '',
                paypass:null,
                wxPhone:''
            },
            
            cashoutMinAmount: 0,
            cashoutFee: 0,
        }
    },
    methods: {
		handleClick(tab, event) {
		        console.log(tab, event);
		      },
        getAgentAccountHandler(){
            getAgentAccount({}).then(res => {
                if(res.data.code == 200){
                    this.tableData = res.data.data.resultList;

                    for(let i=0; i<res.data.data.resultList.length; i++){
                        if(res.data.data.resultList[i].type==10){
                            this.allBalanceRmb = res.data.data.resultList[i].balanceRmb;
                        }
                    }

                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
        getAccountDataHandler(row){
            if(row){
                this.currentId = row.id;
                this.currentAccount = row.typeName;
                this.tbpg.currentPage = 1;
            }
            var data = {
                perPageNum: this.tbpg.pageSize,
                pageNo: this.tbpg.currentPage,
                accountId: this.currentId              
            }
            getAccountData(data).then(res => {
                this.showAccount = true;
                common.listCallback(this, res, 'tbpg');
            })
        },

        applyCashOutHandler(){
            if(Number(this.withdrawalForm.priceRmb) <= 0){
                this.$message.error('请输入提现金额');
                return;
            }
            let data = {"priceRmb":Number(this.withdrawalForm.priceRmb),
                        "withdrawalId": this.withdrawalForm.withdrawalId,
                        "paypass": this.withdrawalForm.paypass,
                        "wxPhone":this.withdrawalForm.wxPhone
                        }

            this.$confirm('确定要提现吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                applyCashOut(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAgentAccountHandler();
                        this.cancelToApply();
                    }else{
                        this.$message.error(res.data.message);
                    }
                    
                })
            }).catch(() => {

            });
        },

        formatPrice(){
            this.withdrawalForm.priceRmb = this.withdrawalForm.priceRmb.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        },
        cancelToApply(){
            this.withdrawalForm.priceRmb = '';
            this.withdrawalForm.paypass = "";
            this.applyVisible = false;
            this.applyVisibles = false;
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAccountDataHandler();
        },
        handleCurrentChange(val){            
            this.tbpg.currentPage = val;
            this.getAccountDataHandler();
        },
        appliyRmb(){
            //获取提现方式及收款账户
        common.sysRequest('agent/withdrawal/list', {}, 'post').then(res => {  
            if(res.data.code == 200){
                this.withdrawalOptions = res.data.data.filter(function(item){
                    if(item.enable){
                        return item;
                    }
                });
            }
        });
            this.applyVisible=true;
        },
        applyCashOutHandlers(){
             common.sysRequest('agent/update/yucun/data', this.agentInfos, 'post').then(res => {  
            if(res.data.code == 200){
               this.$message.success(res.data.message);
            }else{
                        this.$message.error(res.data.message);
                    }
        });
         this.applyVisibles=false;
        },
          appliyRmbs(){
                common.sysRequest('agent/select/yucun/data', {}, 'post').then(res => {  
            if(res.data.code == 200){
                this.agentInfos=res.data.data;
            }else{
                        this.$message.error(res.data.message);
                    }
        });
         this.applyVisibles=true;
     
    },
    },
         
    created(){
        this.getAgentAccountHandler();

        common.sysRequest('agent/account/cashout/config', null, 'post').then(res => {
            if(res.data.code == 200){
                this.cashoutMinAmount = res.data.data.cashoutMinAmount;
                this.cashoutFee = res.data.data.cashoutFee;
            }
        });
    },

}
</script>
<style lang="less" scoped>
#myAccount {
    h3 {
        font-size: 13px;
        font-weight: bold;
        padding-left: 5px;
        margin: 20px 0;
        border-left: 3px solid #409eff;
    }

    .withdrawalForm{
        margin-bottom: 30px;
    }
}


</style>
